import headerImage from '@/assets/images/home.jpg';
import headerImageMobile from '@/assets/images/home-gradient-min.jpg';

const BANNER_DEFAULT = {
  title: 'This is test title text.\nThis is test title text.',
  titleMobile: 'This is test mobile title text. mobile mobile',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean quam neque, aliquet vel tortor molestie, malesuada venenatis ex. Morbi facilisis porttitor egestas. Integer mattis dictum nunc, et elementum diam. Ut nec consequat sem. Pellentesque commodo feugiat dictum. Aenean posuere augue vitae nisl pharetra, ut tempus risus gravida. Maecenas ex arcu, iaculis sit amet enim in, pulvinar condimentum odio. Donec et cursus erat. In eget nulla a nulla accumsan scelerisque et ut purus.',
  descriptionMobile: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
    + 'Aenean quam neque,'
    + 'aliquet vel tortor molestie, malesuada venenatis ex.',
  buttonText: 'desktop button',
  buttonTextMobile: 'mobile button',
  backgroundColor: '#293241',
  backgroundColorMobile: '#FFFFFF',
  beforeText: 'beforeText',
  afterText: 'afterText',
  blocks: [
    {
      imageUrl: headerImage,
      imageUrlMobile: headerImageMobile,
      goldText: 'Default desktop gold text',
      goldTextMobile: 'Default mobile gold text',
    },
  ],
};

export default BANNER_DEFAULT;
